
















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import type { Meta } from '@/models/Meta'
import { SaveMetaDiariaUseCase } from '@/usecases/metaDiaria/SaveMetaDiariaUseCase'
import { FindMetaDiariaUseCase } from '@/usecases/metaDiaria/FindMetaDiariaUseCase'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class DialogoDeDistribuicaoDeMetaDiaria extends Vue {
	@Prop({ type: Object, default: null }) meta!: Meta | null

	mostra = false
	mes: number | null = null
	ano: number | null = null
	distribuindo = false
	jaExistemMetas = false

	saveUseCase = new SaveMetaDiariaUseCase()
	findUseCase = new FindMetaDiariaUseCase()

	mostrar(metaId: string) {
		this.mes = null
		this.ano = null
		this.jaExistemMetas = false
		this.distribuindo = false
		this.mostra = true
	}

	cancelar() {
		this.mostra = false
		this.mes = null
		this.ano = null
		this.jaExistemMetas = false
	}

	get meses() {
		return [
			{ label: 'Janeiro', value: 1 },
			{ label: 'Fevereiro', value: 2 },
			{ label: 'Março', value: 3 },
			{ label: 'Abril', value: 4 },
			{ label: 'Maio', value: 5 },
			{ label: 'Junho', value: 6 },
			{ label: 'Julho', value: 7 },
			{ label: 'Agosto', value: 8 },
			{ label: 'Setembro', value: 9 },
			{ label: 'Outubro', value: 10 },
			{ label: 'Novembro', value: 11 },
			{ label: 'Dezembro', value: 12 },
		]
	}

	get anos() {
		const atual = new Date().getFullYear()
		const lista: number[] = []
		for (let a = atual - 2; a <= atual + 2; a += 1) lista.push(a)
		return lista
	}

	get diasNoMes(): number {
		if (!this.mes || !this.ano) return 0
		return new Date(this.ano, this.mes, 0).getDate()
	}

	get valorPorDia(): number {
		if (!this.meta || !this.diasNoMes) return 0
		return this.meta.valor / this.diasNoMes / (this.meta.vendedorAtribuido.length || 1)
	}

	get superMetaPorDia(): number {
		if (!this.meta?.superMeta || !this.diasNoMes) return 0
		return this.meta.superMeta / this.diasNoMes / (this.meta.vendedorAtribuido.length || 1)
	}

	formatarMoedaLocal(val: number): string {
		return val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
	}

	private async verificarMetasExistentes() {
		if (!this.meta || !this.mes || !this.ano) return
		try {
			const mm = String(this.mes).padStart(2, '0')
			const start = `${this.ano}-${mm}-01`
			const dias = this.diasNoMes
			const dd = String(dias).padStart(2, '0')
			const end = `${this.ano}-${mm}-${dd}`

			const vendedor = this.meta.vendedorAtribuido[0]
			if (!vendedor) return

			const existentes = await this.findUseCase.findByUserAndRange(
				this.meta.id,
				vendedor.id,
				start,
				end,
			)
			this.jaExistemMetas = existentes.length > 0
		} catch {
			this.jaExistemMetas = false
		}
	}

	@Watch('mes')
	@Watch('ano')
	async onMesAnoChange() {
		await this.verificarMetasExistentes()
	}

	async distribuir() {
		if (!this.meta || !this.mes || !this.ano) return

		const dias = this.diasNoMes
		const nVendedores = this.meta.vendedorAtribuido.length || 1
		const valorDia = this.meta.valor / dias / nVendedores
		const superMetaDia = this.meta.superMeta ? this.meta.superMeta / dias / nVendedores : null

		const mm = String(this.mes).padStart(2, '0')

		try {
			this.distribuindo = true

			const itens: import('@/api/metaDiaria').MetaDiariaBatchItem[] = []

			for (const vendedor of this.meta.vendedorAtribuido) {
				for (let d = 1; d <= dias; d++) {
					const dd = String(d).padStart(2, '0')
					itens.push({
						metaId: this.meta.id,
						vendedorId: vendedor.id,
						data: `${this.ano}-${mm}-${dd}`,
						valor: valorDia,
						percentual: this.meta.comissao,
						valorSuperMeta: superMetaDia,
						percentualSuperMeta: this.meta.comissaoSuperMeta ?? null,
					})
				}
			}

			await this.saveUseCase.salvarBatch(itens)

			AlertModule.setSuccess('Metas diárias distribuídas com sucesso!')
			this.$emit('concluiu')
			this.cancelar()
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.distribuindo = false
		}
	}
}
